import { TbProgressCheck } from 'react-icons/tb'

import { dictionaryCodeFormTemplate } from '../Components/DictionaryCodeHint'
import { TopMenu } from '../Components/TopMenu'
import { DICTIONARY_SEARCH_FIELDS } from '../Contracts/DictionaryFields'
import { STATUS_LIST_COLUMNS, STATUS_LIST_FILTERS, statusListFields } from '../Contracts/StatusListFields'
import { CheckDictionaryPageAccessTask } from '../Tasks/CheckDictionaryPageAccessTask'

import type { IResourceConfig } from '@/Core/Contracts/UI'

/**
 * Довідник «Статуси справ» (сім'я `StatusList`, `SPEC-007` §4).
 *
 * Нова чи завершена справа (`SPEC-011`); у легасі довідник звався інакше (`SPEC-002` §2.5).
 *
 * Сторінку бачить лише той, кому бек дає створення довідників, тобто
 * адміністратор (`pageConfig.accessFn`, `SPEC-007` §7.1); читати довідник для
 * селектів може кожен.
 */
export const ListActivityStatusResource: IResourceConfig = {
    title: 'Статуси справ',
    fields: statusListFields(),
    table: {
        showColumns: STATUS_LIST_COLUMNS,
    },
    filter: {
        includeFields: STATUS_LIST_FILTERS,
    },
    // Підказка про код — у формі, над полем «Код» (`SPEC-007` §12)
    form: {
        template: dictionaryCodeFormTemplate,
    },
    places: {
        top: <TopMenu current="activity-statuses" />,
    },
    restUrl: '/services/activity_statuses',
    pageUrl: '/settings/activity-statuses',
    pageConfig: {
        title: 'Статуси справ',
        icon: <TbProgressCheck />,
        accessFn: CheckDictionaryPageAccessTask,
    },
    settings: {
        searchFields: DICTIONARY_SEARCH_FIELDS,
    },
}
